The country to list job categories for.

This is a two-letter ISO 3166-1:2013 country code, in uppercase.

Only use this field if your software has technical limitations that prevent it from dynamically providing a more specific position location to the `jobCategories` query.
Provide `positionProfile.positionLocation` instead and omit this field where possible.
